const autoGenerateStop = true;
const apiKey = "AAPK32ad146723754eb3b233943d3ec885e5tT3d4suGHXf9HIp80DxDnWWTxQXIlXfW0B-uazszAyP9tB6j75gZfVTEF1uANUnM";

export { autoGenerateStop, apiKey };
